export default "__VITE_ASSET__Di3GMfzh__"